import React from 'react';
import { Link } from 'react-router-dom';

function TeleConsultation() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .tele-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Online Tele-Consultation in Delhi NCR: Pre-Travel Virtual Evaluations for International Patients
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Planning an overseas medical itinerary shouldn't involve financial or administrative uncertainty. Before booking a long-haul flight for intricate cardiovascular procedures, robotic joint replacements, or targeted oncology treatments, scheduling a remote clinical evaluation is an essential safety baseline. Virtual care pipelines give international patients the power to discuss diagnostic charts, cross-verify surgical approaches, and secure structural timeline expectations with leading medical specialists.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          By researching communication channels on independent informational platforms like <strong>Medical Trip World</strong>, cross-border healthcare seekers can evaluate the remote consultation networks of premier private hospital systems across New Delhi, Gurgaon, and Noida without regional complications.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Remote Cost Estimation & Consultation Guide →
        </Link>
      </div>

      {/* SECTION 1: THE CORE ADVANTAGES OF PRIVATE TELE-HEALTH */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Why International Patients Prioritize Private Tele-Health Systems
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          Unlike state-funded municipal clinics, elite private multi-specialty healthcare networks in the Delhi National Capital Region (NCR) run specialized international telemedicine lounges. These virtual departments are structurally optimized to manage foreign cases seamlessly:
        </p>
        <ul style={{ paddingLeft: '20px', color: '#444', lineHeight: '1.8', fontSize: '0.95rem' }}>
          <li style={{ marginBottom: '8px' }}>
            <strong>Direct Contact with Senior Consultants:</strong> Private platforms provide direct virtual access to senior department heads and operating surgeons holding prestigious international fellowships, moving past general triage buffers.
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Integrated Multilingual Support:</strong> Corporate international desks coordinate native-speaking translators who join video feeds to ensure clear communication of sensitive medical symptoms.
          </li>
          <li style={{ marginBottom: '0' }}>
            <strong>Validation of Advanced Minimally Invasive Paths:</strong> Remote video reviews allow specialists to assess if advanced keyhole methods—such as robotic-assisted joint fixes or drug-eluting angioplasty stentings—can replace highly invasive conventional surgeries.
          </li>
        </ul>
      </section>

      {/* SECTION 2: DIGITAL FILE CHECKLIST MATRIX */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          How to Prepare Your Diagnostics for a Virtual Medical Review
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          To maximize the efficiency of a cross-border virtual appointment, international patients are advised to organize their medical histories according to these standard clinical data segments:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '25px 0', borderRadius: '6px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.15rem', marginBottom: '12px' }}>📋 Required Digital Health Record Profiles:</h3>
          <ul style={{ marginTop: '10px', listStyleType: 'square', paddingLeft: '20px', lineHeight: '1.8', color: '#333', fontSize: '0.95rem' }}>
            <li style={{ marginBottom: '8px' }}><strong>High-Resolution Universal Radiographic Scans:</strong> Export recent MRI, CT, or coronary angiography files into standard, universal DICOM formats before transmission.</li>
            <li style={{ marginBottom: '8px' }}><strong>Laboratory & Histopathology Summaries:</strong> Gather detailed cellular biopsy findings, blood counts, and metabolic panel printouts translated completely into English.</li>
            <li style={{ marginBottom: '8px' }}><strong>Chronological Medical Briefing:</strong> Provide a typed historical summary tracking past hospitalizations, surgical milestones, and known drug or environmental allergic reactions.</li>
            <li style={{ marginBottom: '0' }}><strong>Active Pharmaceutical Inputs:</strong> Maintain a clear matrix detailing all current daily medications—such as insulin units or active cardiovascular thinning agents.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 3: SAFETY & ENCRYPTED CHANNELS - RESPONSIVE MULTI-CARD */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Data Privacy and Quality Control Benchmarks in Private Systems
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates exclusively as an open informational venue and independent directory reference, we encourage traveling families to directly review the virtual security structures used by foreign medical centers:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Encrypted Telemedicine Portals</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Confirm that the private facility utilizes secure, end-to-end encrypted video channels and encrypted data repositories to safeguard sensitive health histories in full compliance with international patient data privacy regulations.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Independent Verification Rights</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Patients maintain the absolute right to independently cross-check consultant registration credentials and corporate licensing statuses via public national registries before confirming travel packages.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Online Medical Tele-Consultation
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Can an online tele-consultation replace an on-site physical evaluation?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. A remote virtual advisory review serves purely as a pre-travel planning baseline to evaluate existing external diagnostics, discuss surgical choices, and map out cost ranges. Definitive clinical clearances and final operating scripts are determined only after complete, on-site physical evaluations are performed upon arriving at the private facility.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>How long does it take to secure a remote appointment slot with a specialist?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Once translated medical files, historic records, and universal diagnostic images are successfully compiled and delivered to a private hospital's international care team, virtual tele-consultation slots are typically scheduled and confirmed within 48 to 72 business hours.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World employ clinical staff or schedule video feeds?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational reference manual and open directory framework. We do not provide medical services, employ consulting practitioners, or manage remote video software architectures. All clinical assessments, pricing estimates, and virtual consultation contracts occur directly and solely between the patient and their self-selected private medical professional.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="tele-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="tele-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default TeleConsultation;